/*
  TD Draft 2026-10-02 SET-B — Set-Baukasten (sections/td-set-builder.liquid).
  State: Größe + Bezugssystem (L = Schlaufen, Z = Reißverschluss), Decke + Gewicht, 2. Bezug, Filter + Seite je Liste.
  Daten aus <script data-sb-data>: je Produkt nur LIEFERBARE Varianten
  [id, Größe, System, Gewicht, Preis (Cent), Körpergewicht, Versandzeit-Text, Versandzeit in Tagen].
  - Kacheln sind echte Radio-Buttons (eine Tab-Station je Liste, Pfeiltasten wählen), Größe / System / Gewicht Buttons.
  - Nichts wird ohne Hinweis geändert: passt eine Auswahl nach einem Wechsel nicht mehr, wird sie geleert und der Schritt
    sagt es. Hinweise gelten nur für die letzte Änderung.
  - Warenkorb: ein POST /cart/add.js mit Bezug + Decke (die Decke steht dann oben) + versteckter Eigenschaft _td_set
    (aus den beiden Varianten-IDs: dasselbe Set zweimal = Menge 2 statt doppelter Zeilen), danach cart:change mit den
    gebündelten Sektionen und onSuccessDo 'force_open_drawer' (so öffnet Prestige 10 seinen Drawer); im Drawer eine
    „Hinzugefügt“-Zeile mit Fokus (wie Q13 auf der Produktseite). Ohne Drawer oder wenn /cart.js fehlt → /cart.
  - Leiste unten: Handy/Tablet nach dem Set-Bild bis „Ihr Set“; Desktop nur, wenn der Button in „Ihr Set“ nicht ganz
    zu sehen ist; nie über dem Footer.
  SET-B2 (Felix 02.10.2026):
  - Set-Rabatt (d.disc %, Code d.code) auf Decke UND 2. Bezug, je Artikel auf den Cent gerundet (wie Shopify:
    179,00€ → 152,15€, 64,00€ → 54,40€). Oben „Set ab“ rabattiert + Summe durchgestrichen, Kacheln „im Set …“, unten je
    Zeile und Summe, „Sie sparen …“, Leiste. Ohne Code / 0% nur echte Preise.
  - Nach dem Hinzufügen: Codes des Warenkorbs lesen (parallel zum Hinzufügen), unseren dazu (keine Doppelten, Groß-/
    Kleinschreibung egal), POST /cart/update.js mit den Sektionen des Drawers; die Antwort (Warenkorb + Sektionen) geht
    als cart:change an den Drawer. Gilt der Code nicht für die Set-Zeilen: ruhiger Hinweis, keine Ersparnis, und wenn er
    gar nicht gilt, bekommt der Warenkorb seine vorherigen Codes zurück.
  - Seiten: d.per.b / d.per.c Kacheln je Seite (0 = alle). Filter / Größe / System → Seite 1; die Wahl bleibt beim
    Blättern; nach dem Blättern Fokus auf die erste Kachel der neuen Seite.
  - Set-Bild: zwei Felder mit „+“; leer = „?“; neue Bilder erst aus der schon geladenen Kachel, dann scharf.
  SET-B2 Review (02.10.2026):
  - Die Drawer-Sektionen kommen immer mit dem Hinzufügen. Lässt sich der Code nicht einlösen (Warenkorb nicht lesbar,
    Shop ausgelastet), bleiben die Codes unberührt; der Drawer öffnet trotzdem, mit ruhigem Hinweis und „Set-Rabatt
    einlösen“ (auch auf der Seite). Kein Sprung nach /cart ohne Hinweis mehr.
  - „Abgezogen“ nur mit dem Betrag, den Shopify wirklich abzieht: weicht er vom erwarteten Prozentsatz ab, steht nur der
    Betrag da. Beträge je Set (dasselbe Set zweimal = Menge 2: der Betrag eines Sets).
  - Unser Code ohne Wirkung (z. B. Bezug wieder entfernt) wird wieder aus dem Warenkorb genommen, wie CART-UP2 bei
    BEZUG10: nur ein Code, den diese Seite in dieser Sitzung eingelöst hat (sessionStorage td_sb_code).
  - Seiten-Leiste: so viele Seitenzahlen, wie in eine Zeile passen (schmale Handys: 5), nie zweizeilig.
  TD Draft 2026-10-03 SET-B3 (Felix 03.10.2026: „Gewicht selection separate number …“, „change discount to 10% instead of
  15%“, „too much space text in drawer when item is added“, „TRANSLATE“):
  - Set-Rabatt 10% mit TDSLWR7LN (d.code aus den Einstellungen; SET15 und BEZUG10 gibt es seit 03.10. nicht mehr, der Bezug-
    Upsell im Warenkorb heißt jetzt TDB8BNN7R).
  - Vier Schritte: 2 = Decke gewählt, 3 = Gewicht gewählt (eigener Schritt), 4 = 2. Bezug; „Weiter“ in der Leiste führt
    zum nächsten offenen Schritt. Die Gewichts-Überschrift nennt keinen Produktnamen mehr („für …“ entfällt).
  - Im Drawer nur noch eine Zeile „Set hinzugefügt“ (t.added_row), ohne Produktnamen; nur wenn der Set-Rabatt nicht greift
    oder nicht eingelöst werden konnte, folgt der ruhige Hinweis (mit „Set-Rabatt einlösen“).
  - Alle Texte (d.t, d.cl, d.lines) kommen in der Shop-Sprache aus dem Liquid (Deutsch: Einstellungen, sonst td.sb.*).
  TD Draft 2026-10-03 SET-B3 Review (Felix: „TRANSLATE“ – übersetzt so lesbar wie deutsch):
  - Kein Sonderfall mehr für den alten Code SET15 (nur dieser Entwurf hat ihn eingelöst): die Codes des Warenkorbs bleiben.
  - Versandzeit auf der Kachel: „20–24“ bleibt zusammen, der Rest bricht um, statt überzustehen (assets/td-set-builder.css).
  TD Draft 2026-10-03 SET-NEW (Felix 03.10.2026: „lets do B but with a new created set product“): Set-Produkt mit 28
  Varianten (gewichtsdecken-set-mit-2-bezuegen) für Google Shopping / Meta. d.sv = [Set-Variante, Decken-Variante,
  Bezug-Variante, Preis in Cent] aus den Metafeldern custom.set_blanket_variant / custom.set_cover_variant (leer beim
  alten Set-Produkt: dort ändert sich nichts), d.pre = die Variante aus ?variant=, die Liquid bestätigt hat.
  - preselect(): Startwerte = genau dieses Set (Größe + System aus der Decken-Variante, Decke, Gewicht, 2. Bezug, Filter =
    Linie der Kachel, Seite mit der Kachel), geprüft mit den eigenen Regeln (blanketVariant() / coverVariant() müssen
    genau diese Varianten ergeben), sonst Start leer wie bisher. Liquid hat denselben Stand schon gezeichnet: der erste
    render() ändert nichts Sichtbares, kein Fokus, kein Scrollen; das Set-Bild behält das Foto aus dem HTML.
  - Preis oben: entspricht die Auswahl einer Set-Variante, „Ihr Set: [price]“ (t.set_price) mit der regulären Summe
    durchgestrichen, sonst „Set ab“. Immer der berechnete Preis (= Warenkorb); weicht er vom Variantenpreis ab:
    console.warn('td-sb: set variant price differs') für die QA (je Variante einmal).
  - syncUrl(): nach jeder Änderung durch den Kunden ?variant=<id> per history.replaceState, wenn die Auswahl einer
    Set-Variante entspricht (Abgleich über die beiden Metafelder), sonst ohne ?variant; andere Parameter bleiben.
  TD Draft 2026-10-04 SET-EXTRA (Felix 04.10.2026: „The other sets with the Gewichtsmaske and Kragen should also have the option
  to select a blanket and don't stick to just one style.“; Set-Regel: 10% auf alle Artikel des Sets): d.x = Modus
  „Extra-Produkt“ (Decke + Gewichtsschlafmaske / Gewichtskragen). Im Modus „2. Bezug“ (d.x fehlt) ändert sich nichts.
  - d.c = die Varianten des Extra-Produkts, je Eintrag genau eine Variante, markiert mit "x":1 (vars() filtert sie nicht nach
    Größe / Bezugssystem; mt = Zusatz wie „2 kg“). Schritt 4 = kompakte Foto-Felder derselben Radio-Logik wie die Bezüge.
  - Set-Rabatt (d.disc) wird ohne Code gezeigt (Decke UND Extra), nichts wird eingelöst (d.code ist leer).
  - In den Warenkorb: entspricht die Auswahl einer Set-Variante (setVariant()), kommt genau diese (natives Bundle, fester Preis)
    in den Warenkorb – eine Zeile, ohne _td_set; sonst Extra + Decke als zwei Zeilen mit _td_set wie beim 2-Bezüge-Set (die 10%
    sind dort bis zur Entscheidung über die Rabatt-Technik nur Anzeige).
  - d.nox = keine Variante des Extra-Produkts lieferbar: kein Schritt 4, kein Set-Rabatt, nur die Decke (eine Zeile).
  TD Draft 2026-10-05 APP-DISC (Felix 05.10.2026: Rabatt-App SMART Functions Creator freigegeben; Set-Regel: 10% auf ALLE
  Teile eines Sets): den Set-Rabatt zieht die App im Warenkorb ab („Set −10%“ auf jede Zeile mit _td_set; setKey() schreibt
  „<Decke36>-<Partner36>“, die App erkennt das „-“), in beiden Modi.
  - d.code ist leer (Einstellung discount_code): kein /cart/update.js, kein Code wird gelesen, eingelöst oder herausgenommen,
    Codes der Kunden bleiben unberührt. Nach dem Hinzufügen nur „Set hinzugefügt“; die Rabatte zeigt der Warenkorb selbst.
  - discount() zeigt d.disc jetzt auch ohne Code (Anzeige wie bisher: „−10%“, „im Set …“, „Ihr Set“, Leiste).
  - checkIdle()/dropIdle() arbeiten nur noch mit eingetragenem Code: ein alter Eintrag td_sb_code in sessionStorage (frühere
    Tests) wird ohne Code nur gelöscht, nie ein Code aus dem Warenkorb genommen.
  - Ein eingetragener Code würde wie früher eingelöst (alte Technik, nicht mehr verwenden).
*/
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('td-set-builder')) return;

  // the code this page redeemed in this browser session (only that one is taken out again when it has no effect)
  var CODE_KEY = 'td_sb_code';
  var store = {
    get: function (k) {
      try { return window.sessionStorage.getItem(k); } catch (e) { return null; }
    },
    set: function (k, v) {
      try { window.sessionStorage.setItem(k, v); } catch (e) { /* storage blocked: no clean-up, nothing else changes */ }
    },
    remove: function (k) {
      try { window.sessionStorage.removeItem(k); } catch (e) { /* ignore */ }
    }
  };
  function sameCode(a, b) {
    return String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
  }

  /* TD 2026-10-12 WEIGHT-A R3 — body-weight range for the weight line: the identical rules of snippets/td-wa-range.liquid
     (Codex R3; one function per Liquid step, Liquid/Ruby string behaviour copied where it matters). The WHOLE advice
     must be exactly one allowed form: [up to] N <sep> M kg (N < M); [up to] N kg <plus>; <up to> N kg; <from> N kg
     (N > 0) — after the first sentence and a known label. Anything else → null (no line).
     Returns [lower, upper (Infinity = open), lower as written, upper as written]. */
  var WA_LABELS = ['pour un poids corporel allant', 'pour les poids de corps de', 'pour un poids corporel de', 'pour les poids corporels',
    'pour le poids corporel', 'pour un poids corporel', 'voor lichaamsgewicht', 'pour poids corporel', 'para peso corporal',
    'pour les chiens de', 'per peso corporeo', 'für körpergewicht', 'for body weight', 'poids corporel', 'for bodyweight'];
  var WA_SEP = ['-', 'à', 'a', 'bis', 'to', 'tot'];
  var WA_UPTO1 = ['bis', 'hasta', 'tot', 'max', 'maximal', 'maximum'];
  var WA_PLUS = ['+', 'plus', 'et plus', 'et +', 'and more', 'or more', 'and above', 'or above', 'o más', 'y más', 'o mas',
    'y mas', 'e oltre', 'o più', 'e più', 'o piu', 'e piu', 'en meer', 'of meer', 'und mehr', 'oder mehr'];
  var WA_FROM2 = ['more than', 'más de', 'mas de', 'più di', 'piu di', 'meer dan'];
  var WA_FROM1 = ['ab', 'über', 'from', 'over', 'above', 'dès', 'desde', 'da', 'oltre', 'vanaf', 'boven'];
  function waSplit(str, sep) { // Liquid split: empty trailing parts dropped
    var p = str.split(sep);
    while (p.length && p[p.length - 1] === '') p.pop();
    return p;
  }
  function waWords(str) { // Liquid split: ' ' = runs of ASCII white space, no empty parts
    return str.split(/[ \t\n\v\f\r]+/).filter(Boolean);
  }
  function waStrip(str) { // Liquid strip
    return str.replace(/^[ \t\n\v\f\r\0]+|[ \t\n\v\f\r\0]+$/g, '');
  }
  function waIsNum(x) {
    return /^[0-9]+([.,][0-9]+)?$/.test(x);
  }
  function waVal(x) {
    return Number(x.replace(',', '.'));
  }
  function parseRange(text) {
    var s = String(text == null ? '' : text)
      .replace(/<script[\s\S]*?<\/script>/g, '').replace(/<!--[\s\S]*?-->/g, '').replace(/<style[\s\S]*?<\/style>/g, '')
      .replace(/<[\s\S]*?>/g, '').replace(/\r?\n/g, '').toLowerCase()
      .replace(/[  ]/g, ' ').replace(/[–—]/g, '-').replace(/’/g, "'");
    s = waWords(s).join(' ');
    s = waSplit(s, '. ')[0] || '';
    if (s.slice(-1) === '.') s = s.slice(0, -1);
    s = waStrip(s);
    var adv = s, k;
    if (s.indexOf(':') !== -1) {
      var parts = waSplit(s, ':');
      if (parts.length !== 2 || WA_LABELS.indexOf(waStrip(parts[0])) === -1) return null;
      adv = waStrip(parts[1]);
    } else {
      for (k = 0; k < WA_LABELS.length; k++) {
        if (s.indexOf(WA_LABELS[k] + ' ') === 0) { adv = s.slice(WA_LABELS[k].length + 1); break; }
      }
    }
    var tok = waWords(adv.replace(/-/g, ' - ').replace(/\+/g, ' + ').replace(/'/g, " ' ").replace(/kg/g, ' kg '));
    var t0 = tok[0] || '', t1 = tok[1] || '', t2 = tok[2] || '', l = 0;
    if (t0 === 'tot' && t1 === 'en' && t2 === 'met') l = 3;
    else if (t0 === 'jusqu' && t1 === "'" && t2 === 'à') l = 3;
    else if ((t0 === 'bis' && t1 === 'zu') || (t0 === 'up' && t1 === 'to') || (t0 === 'fino' && t1 === 'a')) l = 2;
    else if (WA_UPTO1.indexOf(t0) !== -1) l = 1;
    var rt = tok.slice(l), a;
    if (rt.length === 4 && waIsNum(rt[0]) && !waIsNum(rt[1]) && waIsNum(rt[2]) && rt[3] === 'kg') {
      if (WA_SEP.indexOf(rt[1]) === -1) return null;
      a = waVal(rt[0]);
      var b = waVal(rt[2]);
      return a < b ? [a, b, rt[0], rt[2]] : null;
    }
    if (rt.length >= 3 && waIsNum(rt[0]) && rt[1] === 'kg') {
      if (WA_PLUS.indexOf(rt.slice(2).join(' ')) === -1) return null;
      a = waVal(rt[0]);
      return a > 0 ? [a, Infinity, rt[0], ''] : null;
    }
    if (l > 0) {
      if (rt.length === 2 && waIsNum(rt[0]) && rt[1] === 'kg') {
        a = waVal(rt[0]);
        return a > 0 ? [0, a, '0', rt[0]] : null;
      }
      return null;
    }
    var fl = 0;
    if (tok.slice(0, 3).join(' ') === 'à partir de') fl = 3;
    else if (WA_FROM2.indexOf(tok.slice(0, 2).join(' ')) !== -1) fl = 2;
    else if (WA_FROM1.indexOf(t0) !== -1) fl = 1;
    if (fl > 0 && tok.length === fl + 2 && waIsNum(tok[fl]) && tok[fl + 1] === 'kg') {
      a = waVal(tok[fl]);
      return a > 0 ? [a, Infinity, tok[fl], ''] : null;
    }
    return null;
  }

  function num(w) {
    var m = String(w || '').replace(',', '.').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : 0;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }
  // one hidden id per combination: the same set added twice merges into the same two lines (quantity 2)
  function setKey(a, b) {
    return Number(a).toString(36) + '-' + Number(b).toString(36);
  }
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function wait(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }
  // page buttons for `slots` places between ‹ and ›: all pages when they fit, otherwise 1 … around the current … last
  function pageList(p, n, slots) {
    var out = [], i;
    slots = slots || 7;
    if (n <= slots) {
      for (i = 1; i <= n; i++) out.push(i);
      return out;
    }
    if (slots < 7) {
      // narrow phones: 1 2 3 … 9 | 1 … 5 … 9 | 1 … 7 8 9
      if (p <= 2) return [1, 2, 3, 0, n];
      if (p >= n - 1) return [1, 0, n - 2, n - 1, n];
      return [1, 0, p, 0, n];
    }
    var a = Math.max(2, p - 1), b = Math.min(n - 1, p + 1);
    if (p <= 4) { a = 2; b = 5; }
    if (p >= n - 3) { a = n - 4; b = n - 1; }
    out.push(1);
    if (a > 2) out.push(0);
    for (i = a; i <= b; i++) out.push(i);
    if (b < n - 1) out.push(0);
    out.push(n);
    return out;
  }

  /* same calendar icon as snippets/td-p03-lead-note.liquid (styles: assets/td-draft-0928-p03.css, loaded on every page) */
  var CAL_ICON = '<svg class="td-p03-lead__icon" aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 9.5h17M8 3v4M16 3v4"/></svg>';
  var OK_ICON = '<svg class="td-sb-added__icon" aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.4l3.2 3.1L17 8.8" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  class TdSetBuilder extends HTMLElement {
    connectedCallback() {
      if (this._sb) return;
      var raw = this.querySelector('script[data-sb-data]');
      if (!raw) return;
      this._sb = true;
      try {
        this.setup(JSON.parse(raw.textContent));
      } catch (e) {
        if (window.console) console.warn('[td-set-builder]', e);
      }
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      this._io = null;
      if (this._ro) this._ro.disconnect();
      this._ro = null;
      if (this._mq && this._mqH) {
        if (this._mq.removeEventListener) this._mq.removeEventListener('change', this._mqH);
        else if (this._mq.removeListener) this._mq.removeListener(this._mqH);
      }
      this._mq = null;
      if (this._cartH) document.removeEventListener('cart:change', this._cartH);
      this._cartH = null;
      clearTimeout(this._idleT);
      this._sb = false;
    }

    setup(d) {
      var self = this;
      this.d = d;
      this.t = d.t || {};
      // SET-EXTRA: extra product instead of the 2nd cover; noX = none of its variants can be ordered (blanket only)
      this.xm = !!d.x;
      this.noX = this.xm && !!d.nox;
      this.longDays = Number(d.longLead) || 14;
      this.per = { b: Number(d.per && d.per.b) || 0, c: Number(d.per && d.per.c) || 0 };
      this.map = { b: {}, c: {} };
      (d.b || []).forEach(function (p) { self.map.b[p.id] = p; });
      (d.c || []).forEach(function (p) { self.map.c[p.id] = p; });
      this.sizeLabel = {};
      (d.sizes || []).forEach(function (s) { self.sizeLabel[s[0]] = s[1]; });
      this.st = { size: d.size0, cl: d.cl0 || 'L', b: null, w: null, c: null, fb: 0, fc: 0, pb: 1, pc: 1, touched: false };
      // SET-NEW: set variants of this product + the set from ?variant= (before the first render: nothing moves)
      this.sv = Array.isArray(d.sv) ? d.sv : [];
      this._warned = {};
      this.preselect(Number(d.pre) || 0);
      this._pg = {};
      // CL-POPUP (05.10.2026): the closure link opens a popup with a copy of the photo section; without it, no link
      this.qa('[data-sb-difflink]').forEach(function (a) {
        if (!document.getElementById(a.getAttribute('data-sb-diff-target') || '')) a.hidden = true;
      });
      if (!this._listen) {
        // once per element, even if the theme editor re-attaches it
        this._listen = true;
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
      }
      if (!this._cartH) {
        // every cart change while the page is open (drawer: remove, quantity, codes)
        this._cartH = this.onCartChange.bind(this);
        document.addEventListener('cart:change', this._cartH);
      }
      this.setupBar();
      this.render();
      if ('ResizeObserver' in window) {
        // the page row holds as many numbers as fit (rotating a phone, resizing a window)
        this._ro = new ResizeObserver(function () {
          cancelAnimationFrame(self._roF);
          self._roF = requestAnimationFrame(function () {
            ['b', 'c'].forEach(function (k) {
              var a = self._pg[k];
              if (a) self.renderPager.apply(self, [k].concat(a));
            });
          });
        });
        this.qa('[data-sb-pagerwrap]').forEach(function (w) { self._ro.observe(w); });
      }
      this.classList.add('is-ready');
      // our code from an earlier visit may have lost its effect meanwhile (e.g. the cover was removed on another page);
      // APP-DISC: without a configured code nothing is checked, an old entry is only forgotten
      if (!this.code()) store.remove(CODE_KEY);
      else if (store.get(CODE_KEY)) this.getCart(this.root()).then(function (c) { self.checkIdle(c); });
    }

    /* ---------- helpers ---------- */
    q(s) { return this.querySelector(s); }
    qa(s) { return Array.prototype.slice.call(this.querySelectorAll(s)); }

    root() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || this.d.root || '/';
      return r.slice(-1) === '/' ? r : r + '/';
    }

    // the sections the theme wants with every cart change (the drawer), like the theme's own product form
    bundledSections() {
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      return sections;
    }

    // height of the sticky header (the theme's --sticky-area-height is a calc(), so it is measured)
    stickyTop() {
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;top:0;left:0;width:1px;visibility:hidden;pointer-events:none;height:var(--sticky-area-height, 0px)';
      document.body.appendChild(probe);
      var h = probe.offsetHeight || 0;
      probe.remove();
      return h;
    }

    money(c) {
      var n = (c || 0) / 100;
      if (this.d.cur === 'EUR' || !this.d.cur) {
        // Felix: no space before € ('179,00€'); toLocaleString may emit U+00A0 / U+202F
        return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/[\s  ]/g, '') + '€';
      }
      try {
        return new Intl.NumberFormat(this.d.loc || 'de', { style: 'currency', currency: this.d.cur }).format(n);
      } catch (e) {
        return n.toFixed(2) + ' ' + (this.d.sym || this.d.cur);
      }
    }

    // the set discount code, '' when the page shows no discount
    code() {
      return (Number(this.d.disc) || 0) > 0 && this.d.code ? String(this.d.code).trim() : '';
    }

    vars(p, size, cl) {
      if (!p) return [];
      if (p.x) return p.v; // SET-EXTRA: an extra variant fits every size / closure
      size = size || this.st.size;
      cl = cl || this.st.cl;
      return p.v.filter(function (v) { return v[1] === size && v[2] === cl; });
    }

    fullName(p) {
      if (!p) return '';
      return (p.ln ? p.ln + ' ' : '') + (p.m || p.n);
    }

    sameKey(p) {
      return p ? (p.l || 0) + '|' + String(p.m || p.n).toLowerCase().trim() : '';
    }

    weights(vs) {
      var seen = {};
      return vs.map(function (v) { return v[3]; }).filter(function (w) {
        if (!w || seen[w]) return false;
        seen[w] = true;
        return true;
      }).sort(function (a, b) { return num(a) - num(b); });
    }

    weightList(vs) {
      return this.weights(vs).join(', ');
    }

    // SET-B3: number and "kg" stay together (no-break space) – longer words abroad ("hasta", "desde") wrap before them
    rangeText(raw) {
      var r = parseRange(raw);
      if (!r) return '';
      if (r[1] === Infinity) return fill(this.t.range_from, { kg: r[2] + '\u00a0kg' });
      if (r[0] === 0) return fill(this.t.range_to, { kg: r[3] + '\u00a0kg' });
      return r[2] + '–' + r[3] + '\u00a0kg';
    }

    // set discount of one item in cents (Shopify: per line, rounded to the cent); 0 once the cart refused the code
    discount(cents) {
      // SET-EXTRA: the set discount shows without a code (nothing is redeemed); APP-DISC: in both modes — the discount
      // app deducts it from every _td_set line
      var pct = !this._noDisc ? Number(this.d.disc) || 0 : 0;
      return pct > 0 ? Math.round(cents * pct / 100) : 0;
    }

    // the cart did not apply our code to the set: the page shows plain prices (no saving it cannot keep) until a
    // later add applies it again
    setNoDisc(on) {
      on = !!on;
      if (!!this._noDisc === on) return;
      this._noDisc = on;
      this.classList.toggle('is-nodisc', on);
      this.render();
    }

    priceRange(vs) {
      var ps = vs.map(function (v) { return v[4]; });
      return [Math.min.apply(null, ps), Math.max.apply(null, ps)];
    }

    blanketVariant() {
      var st = this.st;
      if (!st.b || !st.w) return null;
      var vs = this.vars(this.map.b[st.b]);
      for (var i = 0; i < vs.length; i++) if (vs[i][3] === st.w) return vs[i];
      return null;
    }

    coverVariant() {
      var st = this.st;
      if (!st.c) return null;
      var vs = this.vars(this.map.c[st.c]);
      if (!vs.length) return null;
      return vs.slice().sort(function (a, b) { return a[4] - b[4]; })[0];
    }

    count(kind, line, size, cl) {
      var list = kind === 'b' ? this.d.b : this.d.c, n = 0, self = this;
      (list || []).forEach(function (p) {
        if (line && p.l !== line) return;
        if (self.vars(p, size, cl).length) n++;
      });
      return n;
    }

    /* ---------- TD Draft 2026-10-03 SET-NEW: set product with variants („lets do B but with a new created set product“) ---------- */

    // page of a tile within the filter `line` (0 = all), counted like renderList(): tiles offered in the size + closure
    pageOf(kind, id, line) {
      var per = this.per[kind] || 0, i = 0, at = -1, self = this;
      ((kind === 'b' ? this.d.b : this.d.c) || []).forEach(function (p) {
        if (at >= 0 || !self.vars(p).length || (line && p.l !== line)) return;
        if (p.id === id) at = i;
        i++;
      });
      return per && at >= 0 ? Math.floor(at / per) + 1 : 1;
    }

    // start with the set from ?variant= (Liquid confirmed it and already drew this state); checked again with the rules of
    // this script: blanketVariant() and coverVariant() must give exactly the two variants, otherwise the builder starts
    // empty as before. No focus, no scrolling, no announcement.
    preselect(id) {
      var st = this.st, d = this.d, sv = null, pb = null, vb = null, pc = null;
      if (!id) return;
      this.sv.forEach(function (s) { if (s[0] === id) sv = s; });
      if (!sv) return;
      (d.b || []).forEach(function (p) {
        p.v.forEach(function (v) { if (!vb && v[0] === sv[1]) { pb = p; vb = v; } });
      });
      (d.c || []).forEach(function (p) {
        p.v.forEach(function (v) { if (!pc && v[0] === sv[2]) pc = p; });
      });
      if (!pb || !vb || !vb[3] || !pc || !this.sizeLabel[vb[1]]) return;
      var keep = { size: st.size, cl: st.cl };
      st.size = vb[1];
      st.cl = vb[2];
      st.b = pb.id;
      st.w = vb[3];
      st.c = pc.id;
      var ob = this.blanketVariant(), oc = this.coverVariant();
      if (!ob || ob[0] !== sv[1] || !oc || oc[0] !== sv[2]) {
        st.size = keep.size;
        st.cl = keep.cl;
        st.b = st.w = st.c = null;
        return;
      }
      st.fb = pb.l || 0;
      st.fc = pc.l || 0;
      st.pb = this.pageOf('b', pb.id, st.fb);
      st.pc = this.pageOf('c', pc.id, st.fc);
      this.checkSetPrice(sv);
    }

    // the set variant of this product that equals the selection (match by the two metafields), else null
    setVariant() {
      if (!this.sv.length) return null;
      var vb = this.blanketVariant(), vc = this.coverVariant(), hit = null;
      if (!vb || !vc) return null;
      this.sv.forEach(function (s) { if (!hit && s[1] === vb[0] && s[2] === vc[0]) hit = s; });
      return hit;
    }

    // QA: the page shows the price the builder computes (= the cart with the set code); it must equal the variant price
    // that Google Shopping / Meta show for this URL
    checkSetPrice(sv) {
      var s = sv ? this.sums() : null;
      if (!s || s.total === sv[3] || this._warned[sv[0]]) return;
      this._warned[sv[0]] = true;
      if (window.console && console.warn) {
        console.warn('td-sb: set variant price differs', { variant: sv[0], variantPrice: sv[3], builderPrice: s.total });
      }
    }

    // after a change by the shopper: ?variant=<id> when the selection is one of the set variants, otherwise no ?variant;
    // all other parameters and the hash stay as they are (only on products with set variants)
    syncUrl() {
      if (!this.sv.length || !window.history || typeof window.history.replaceState !== 'function') return;
      var sv = this.setVariant(), want = sv ? String(sv[0]) : '';
      if (sv) this.checkSetPrice(sv);
      var loc = window.location, found = false;
      var parts = loc.search.replace(/^\?/, '').split('&').filter(Boolean);
      var out = [];
      parts.forEach(function (p) {
        if (p.split('=')[0] !== 'variant') return out.push(p);
        if (want && !found) out.push('variant=' + want);
        found = true;
      });
      if (want && !found) out.push('variant=' + want);
      var search = out.length ? '?' + out.join('&') : '';
      if (search === loc.search) return;
      try {
        window.history.replaceState(window.history.state, '', loc.pathname + search + loc.hash);
      } catch (e) { /* the URL stays, nothing else depends on it */ }
    }

    // lead time of a variant list: the shortest one when ALL are long (tile hint), else null
    longLead(vs) {
      if (!vs.length) return null;
      var min = null;
      for (var i = 0; i < vs.length; i++) {
        var dd = Number(vs[i][7]) || 0;
        if (dd < this.longDays) return null;
        if (!min || dd < (Number(min[7]) || 0)) min = vs[i];
      }
      return min ? min[6] : null;
    }

    say(msg, urgent, delay) {
      var el = this.q(urgent ? '[data-sb-alert]' : '[data-sb-live]');
      if (!el || !msg) return;
      el.textContent = '';
      clearTimeout(urgent ? this._alertT : this._sayT);
      var t = setTimeout(function () { el.textContent = msg; }, delay || 80);
      if (urgent) this._alertT = t; else this._sayT = t;
    }

    notice(kind, msg) {
      var el = this.q('[data-sb-notice="' + kind + '"]');
      if (el) el.textContent = msg || '';
    }

    clearNotices() {
      this.notice('b', '');
      this.notice('w', '');
      this.notice('c', '');
    }

    // messages of an earlier add ("liegt im Warenkorb" / error) do not belong to a changed selection; the note that the
    // set discount does not apply stays while the page shows plain prices because of it, and the note with
    // "Set-Rabatt einlösen" stays while the set in the cart still waits for its discount
    clearMsgs() {
      ['[data-sb-msg]', '[data-sb-ok]'].forEach(function (s) {
        var el = this.q(s);
        if (el) el.textContent = '';
      }, this);
      this._claim = false;
      if (!this._noDisc && !this._discErr) this.discMsg('');
    }

    // calm note about the set discount below the button; retry = with the button "Set-Rabatt einlösen"
    discMsg(text, retry) {
      var box = this.q('[data-sb-dbox]'), msg = this.q('[data-sb-dmsg]'), btn = this.q('[data-sb-retry]');
      if (msg) msg.textContent = text || '';
      if (btn) btn.hidden = !(text && retry);
      if (box) box.hidden = !text;
    }

    // set prices of the picked variants: regular sum, saving, set total
    sums() {
      var vb = this.blanketVariant(), vc = this.noX ? null : this.coverVariant();
      if (!vb || (!vc && !this.noX)) return null;
      var reg = vb[4] + (vc ? vc[4] : 0), save = this.discount(vb[4]) + (vc ? this.discount(vc[4]) : 0);
      return { reg: reg, save: save, total: reg - save };
    }

    totalSay() {
      var s = this.sums();
      if (!s) return '';
      return ' ' + fill(this.t.live_total, { price: this.money(s.total) }) +
        (s.save > 0 && this.t.live_save ? ' ' + fill(this.t.live_save, { amount: this.money(s.save), pct: this.d.disc }) : '');
    }

    /* ---------- events ---------- */
    onChange(e) {
      var inp = e.target;
      if (!inp || !inp.matches || !inp.matches('input[data-sb-pick]')) return;
      var kind = inp.dataset.sbPick;
      if (this._busy) {
        this.renderList(kind); // nothing changes while the set is being added
        return;
      }
      this.pick(kind, Number(inp.value));
    }

    onClick(e) {
      var link = e.target.closest('[data-sb-difflink]');
      if (link) {
        // CL-POPUP (Felix 05.10.2026: "should be a popup"): the theme modal opens through aria-controls; its content
        // is made here on the first click
        this.fillClosurePopup(link);
        return;
      }
      var btn = e.target.closest('button');
      if (!btn || !this.contains(btn) || btn.disabled) return;
      if (this._busy || btn.getAttribute('aria-disabled') === 'true') return;
      var ds = btn.dataset;
      if (ds.sbPg) {
        var wrap = btn.closest('[data-sb-pagerwrap]');
        return wrap ? this.goPage(wrap.dataset.sbPagerwrap, ds.sbPg) : undefined;
      }
      if (ds.sbSize) return this.setOption('size', ds.sbSize);
      if (ds.sbClosure) return this.setOption('cl', ds.sbClosure);
      if (ds.sbChip) return this.setFilter(ds.sbChip, Number(ds.line) || 0);
      if (ds.sbWeight != null) return this.pickWeight(ds.sbWeight);
      if (btn.hasAttribute('data-sb-add')) return this.addToCart(false);
      if (btn.hasAttribute('data-sb-retry')) return this.retryCode();
      if (btn.hasAttribute('data-sb-barbtn')) return this.barAction();
      if (btn.hasAttribute('data-sb-barpics')) return this.toPanel();
    }

    /* CL-POPUP — copy of the photo section (sections/td-product-option-columns.liquid: Schlaufen / Reißverschluss) for
       the popup. Its <style> rules are scoped to the section id, so the copy gets a class instead and the rules are
       rewritten to that class; ids, the section's margins and theme-editor attributes are dropped from the copy. Made once;
       the original section stays on the page. */
    fillClosurePopup(link) {
      var modal = document.getElementById(link.getAttribute('aria-controls') || '');
      var box = modal && modal.querySelector('[data-sb-clm]');
      var src = document.getElementById(link.getAttribute('data-sb-diff-target') || '');
      if (!box || !src || box.firstElementChild) return;
      var scope = 'td-sb-clm__copy';
      var copy = src.cloneNode(true);
      copy.removeAttribute('id');
      copy.setAttribute('class', scope);
      copy.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      copy.querySelectorAll('[data-shopify-editor-block], [data-shopify-editor-section]').forEach(function (n) {
        n.removeAttribute('data-shopify-editor-block');
        n.removeAttribute('data-shopify-editor-section');
      });
      copy.querySelectorAll('.td-product-option-columns').forEach(function (n) { n.removeAttribute('style'); });
      copy.querySelectorAll('style').forEach(function (s) {
        s.textContent = s.textContent.split('#' + src.id).join('.' + scope);
      });
      box.appendChild(copy);
    }

    setOption(key, val) {
      this.st.touched = true;
      this.clearMsgs();
      if (this.st[key] === val) return this.renderSummary();
      this.clearNotices();
      this.st[key] = val;
      // other size / system = other tiles: both lists start on page 1
      this.st.pb = 1;
      this.st.pc = 1;
      var msgs = this.revalidate();
      this.render();
      this.syncUrl(); // SET-NEW
      var d = this.d;
      this.say((this.sizeLabel[this.st.size] || this.st.size) + ', ' + (d.cl[this.st.cl] || '') + '.' +
        (msgs.length ? ' ' + msgs.join(' ') : '') + this.totalSay());
    }

    // after a size / closure change: drop what no longer exists and say so (until the next change)
    revalidate() {
      var st = this.st, t = this.t, msgB = '', msgW = '', msgC = '';
      var place = { size: this.sizeLabel[st.size] || st.size, closure: this.d.cl[st.cl] || '' };
      if (st.b) {
        var p = this.map.b[st.b], vs = this.vars(p);
        if (!vs.length) {
          msgB = fill(t.gone_b, { name: this.fullName(p), size: place.size, closure: place.closure });
          st.b = null;
          st.w = null;
        } else if (st.w && !vs.some(function (v) { return v[3] === st.w; })) {
          msgW = fill(t.weight_reset, { kg: st.w, weights: this.weightList(vs) });
          st.w = null;
        }
        if (st.b && !st.w) {
          var ws = this.weights(vs);
          if (ws.length === 1) {
            st.w = ws[0];
            msgW = (msgW ? msgW + ' ' : '') + fill(t.weight_auto, { kg: st.w });
          }
        }
      }
      if (st.c) {
        var pc = this.map.c[st.c];
        if (!this.vars(pc).length) {
          msgC = fill(t.gone_c, { name: this.fullName(pc), size: place.size, closure: place.closure });
          st.c = null;
        }
      }
      if (st.fb && !this.count('b', st.fb)) st.fb = 0;
      if (st.fc && !this.count('c', st.fc)) st.fc = 0;
      if (msgB) this.notice('b', msgB);
      if (msgW) this.notice('w', msgW);
      if (msgC) this.notice('c', msgC);
      return [msgB, msgW, msgC].filter(Boolean);
    }

    setFilter(kind, line) {
      if (kind === 'b') {
        this.st.fb = line;
        this.st.pb = 1;
      } else {
        this.st.fc = line;
        this.st.pc = 1;
      }
      this.renderList(kind);
    }

    // paging: new page, focus on its first tile (the list top comes into view when it was scrolled away)
    goPage(kind, val) {
      var key = kind === 'b' ? 'pb' : 'pc', cur = this.st[key] || 1;
      var n = val === 'prev' ? cur - 1 : (val === 'next' ? cur + 1 : Number(val));
      if (!n || n < 1 || n === cur) return;
      this.st[key] = n;
      var pg = this.renderList(kind) || {};
      var grid = this.q('[data-sb-tiles="' + kind + '"]');
      if (!grid) return;
      var step = grid.closest('[data-sb-step]');
      var chips = step ? step.querySelector('.td-sb__chips') : null;
      var top = chips || grid;
      if (top.getBoundingClientRect().top < this.stickyTop() + 8) {
        top.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }
      var first = grid.querySelector('[data-sb-cell]:not([hidden]) input[data-sb-pick]');
      focusEl(first);
      if (this.t.live_page) this.say(fill(this.t.live_page, { n: pg.page || n, pages: pg.pages || '', info: pg.info || '' }));
    }

    pick(kind, id) {
      var st = this.st, t = this.t;
      if (kind === 'b') {
        var p = this.map.b[id];
        if (!p || st.b === id) return;
        var vs = this.vars(p), msg = '';
        this.clearMsgs();
        st.b = id;
        if (st.w && !vs.some(function (v) { return v[3] === st.w; })) {
          msg = fill(t.weight_reset, { kg: st.w, weights: this.weightList(vs) });
          st.w = null;
        }
        if (!st.w) {
          var ws = this.weights(vs);
          if (ws.length === 1) {
            st.w = ws[0];
            msg = (msg ? msg + ' ' : '') + fill(t.weight_auto, { kg: st.w });
          }
        }
        this.clearNotices();
        this.notice('w', msg);
        this.render();
        this.syncUrl(); // SET-NEW
        // a little later: arrow keys walk through the tiles, only the last choice is read out
        this.say(fill(t.live_b, { name: this.fullName(p) }) + (msg ? ' ' + msg : '') + this.totalSay(), false, 450);
      } else {
        var pc = this.map.c[id];
        if (!pc || st.c === id) return;
        this.clearMsgs();
        st.c = id;
        this.clearNotices();
        this.render();
        this.syncUrl(); // SET-NEW
        this.say(fill(t.live_c, { name: this.fullName(pc) }) + this.totalSay(), false, 450);
      }
    }

    pickWeight(w) {
      if (!this.st.b || this.st.w === w) return;
      this.clearMsgs();
      this.st.w = w;
      this.clearNotices();
      this.render();
      this.syncUrl(); // SET-NEW
      // WEIGHT-A: the body-weight range (no longer part of the button's name) is read with the choice
      var wr = this.weightRangeText();
      this.say(fill(this.t.live_w, { kg: w }) + (wr ? ' ' + wr + '.' : '') + this.totalSay());
    }

    /* ---------- rendering ---------- */
    render() {
      var st = this.st, d = this.d, t = this.t;
      this.qa('[data-sb-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.sbSize === st.size)); });
      this.qa('[data-sb-closure]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.sbClosure === st.cl)); });
      this.renderList('b');
      this.renderList('c');
      this.renderWeights();
      var fit = this.q('[data-sb-fit]');
      if (fit) fit.textContent = fill(t.fit, { size: this.sizeLabel[st.size] || st.size, closure: d.cl[st.cl] || '' });
      this.renderFrom();
      this.renderSummary();
    }

    // "Set ab 185,40€"; SET-EXTRA without an orderable extra: "ab 179,00€" (the blanket alone, no set)
    fromText(cents) {
      return this.noX ? (this.t.from_price || 'ab') + ' ' + this.money(cents) : fill(this.t.from_set, { price: this.money(cents) });
    }

    // regular price of a tile ("ab 179,00€"), plain text
    priceText(vs) {
      if (!vs.length) return '';
      var r = this.priceRange(vs);
      return (r[1] > r[0] ? (this.t.from_price || 'ab') + ' ' : '') + this.money(r[0]);
    }

    // small set price of a tile ("im Set ab 152,15€"), '' without a discount
    inSetText(vs) {
      if (!vs.length || !this.t.in_set) return '';
      var r = this.priceRange(vs), off = this.discount(r[0]);
      if (!off) return '';
      return fill(this.t.in_set, { price: (r[1] > r[0] ? (this.t.from_price || 'ab') + ' ' : '') + this.money(r[0] - off) });
    }

    // "152,15€ statt 179,00€" (set price, regular struck through); without a discount the regular price
    priceHtml(cents, from) {
      var off = this.discount(cents), pre = from ? esc(this.t.from_price || 'ab') + ' ' : '';
      if (!off) return pre + esc(this.money(cents));
      return '<span class="td-sb__now">' + pre + esc(this.money(cents - off)) + '</span> <s>' + this.srInstead() + esc(this.money(cents)) + '</s>';
    }

    srInstead() {
      return this.t.sr_instead ? '<span class="sr-only">' + esc(this.t.sr_instead) + ' </span>' : '';
    }

    renderList(kind) {
      var self = this, st = this.st, t = this.t;
      var filt = kind === 'b' ? st.fb : st.fc, sel = st[kind], counts = [0, 0, 0, 0];
      var same = kind === 'c' && st.b ? this.sameKey(this.map.b[st.b]) : '';
      var per = this.per[kind] || 0, pageKey = kind === 'b' ? 'pb' : 'pc';
      var cells = this.qa('[data-sb-tiles="' + kind + '"] [data-sb-cell]').map(function (li) {
        var id = Number(li.dataset.id), p = self.map[kind][id];
        var vs = self.vars(p), ok = vs.length > 0;
        if (ok) {
          counts[0]++;
          if (p.l) counts[p.l]++;
        }
        return { li: li, id: id, p: p, vs: vs, ok: ok, match: ok && (!filt || p.l === filt) };
      });
      // the matching tiles in list order (bestsellers first); with paging only the current page is shown
      var match = cells.filter(function (x) { return x.match; });
      var pages = per ? Math.max(1, Math.ceil(match.length / per)) : 1;
      var page = Math.min(Math.max(1, st[pageKey] || 1), pages);
      st[pageKey] = page;
      var from = per ? (page - 1) * per : 0, to = per ? Math.min(from + per, match.length) : match.length;
      var selPage = 0;
      match.forEach(function (x, i) {
        x.show = i >= from && i < to;
        if (x.id === sel) selPage = per ? Math.floor(i / per) + 1 : 1;
      });
      cells.forEach(function (x) {
        var li = x.li, p = x.p, vs = x.vs, ok = x.ok;
        li.hidden = !x.show;
        var on = x.id === sel;
        var tile = li.querySelector('[data-sb-tile]');
        if (tile) tile.classList.toggle('is-selected', on);
        // hidden radios (filtered out / other page) leave the group (other name, unchecked): Chrome otherwise skips the
        // whole group on Tab when its first or last-focused radio is hidden; the visible ones keep one Tab stop + arrows
        var inp = li.querySelector('input[data-sb-pick]');
        if (inp) {
          if (!inp.dataset.sbName) inp.dataset.sbName = inp.name;
          inp.name = li.hidden ? inp.dataset.sbName + '-off' : inp.dataset.sbName;
          inp.checked = on && !li.hidden;
        }
        var pr = li.querySelector('[data-sb-price]');
        if (pr && ok) pr.textContent = self.priceText(vs);
        var sp = li.querySelector('[data-sb-setprice]');
        if (sp) sp.textContent = ok ? self.inSetText(vs) : '';
        var lead = li.querySelector('[data-sb-tlead]');
        if (lead) {
          var lt = ok ? self.longLead(vs) : null;
          lead.hidden = !lt;
          if (lead._v !== lt) {
            // label, then the value ("Versandzeit:" / "20–24 Werktage")
            lead._v = lt;
            lead.textContent = '';
            if (lt) {
              if (t.lead_label) lead.appendChild(document.createTextNode(t.lead_label + ' '));
              var val = document.createElement('b');
              // SET-B3 Review: longer units abroad ("20–24 jours ouvrables") wrap inside the tile; the range ("20–24")
              // stays on one line
              var sp = String(lt).indexOf(' '), nw = document.createElement('span');
              nw.className = 'td-sb__nw';
              nw.textContent = sp > 0 ? lt.slice(0, sp) : lt;
              val.appendChild(nw);
              if (sp > 0) val.appendChild(document.createTextNode(lt.slice(sp)));
              lead.appendChild(val);
            }
          }
        }
        var badge = li.querySelector('[data-sb-same]');
        if (badge) badge.hidden = !(same && self.sameKey(p) === same);
      });
      this.qa('[data-sb-chip="' + kind + '"]').forEach(function (ch) {
        var l = Number(ch.dataset.line) || 0, n = counts[l] || 0;
        var nEl = ch.querySelector('[data-sb-n]');
        if (nEl) nEl.textContent = n;
        ch.disabled = l !== 0 && n === 0;
        ch.setAttribute('aria-pressed', String(l === filt));
      });
      var empty = this.q('[data-sb-empty="' + kind + '"]');
      if (empty) empty.hidden = counts[0] > 0;
      this._pg[kind] = [page, pages, match.length, from, to, selPage];
      return this.renderPager(kind, page, pages, match.length, from, to, selPage);
    }

    // places for page numbers between ‹ and › in one row (5–7): measured, so the row never breaks (Review: 375px)
    pagerSlots(wrap) {
      var nav = wrap.querySelector('.td-sb__pager'), step = wrap.querySelector('[data-sb-pg="prev"]');
      var w = wrap.clientWidth, b = step ? step.offsetWidth : 0;
      if (!nav || !w || !b) return 7;
      var g = parseFloat(window.getComputedStyle(nav).columnGap) || 0;
      return Math.max(5, Math.min(7, Math.floor((w + g) / (b + g)) - 2));
    }

    renderPager(kind, page, pages, total, from, to, selPage) {
      var t = this.t, wrap = this.q('[data-sb-pagerwrap="' + kind + '"]');
      var info = total ? fill(t['pginfo_' + kind], { from: from + 1, to: to, total: total }) : '';
      if (!wrap) return { page: page, pages: pages, info: info };
      wrap.hidden = pages < 2;
      var list = wrap.querySelector('[data-sb-pglist]');
      var slots = wrap.hidden ? 7 : this.pagerSlots(wrap);
      var key = page + '|' + pages + '|' + selPage + '|' + slots;
      if (list && wrap._key !== key) {
        wrap._key = key;
        list.innerHTML = pageList(page, pages, slots).map(function (n) {
          if (!n) return '<span class="td-sb__pg-gap" aria-hidden="true">…</span>';
          return '<button type="button" class="td-sb__pg' + (n === selPage ? ' has-sel' : '') + '" data-sb-pg="' + n + '"' +
            ' aria-label="' + esc(fill(n === selPage && t.page_sel ? t.page_sel : t.page, { n: n })) + '"' +
            (n === page ? ' aria-current="page"' : '') + '>' + n + '</button>';
        }).join('');
      }
      var prev = wrap.querySelector('[data-sb-pg="prev"]'), next = wrap.querySelector('[data-sb-pg="next"]');
      if (prev) prev.disabled = page <= 1;
      if (next) next.disabled = page >= pages;
      var infoEl = wrap.querySelector('[data-sb-pginfo]');
      if (infoEl) infoEl.textContent = info;
      return { page: page, pages: pages, info: info };
    }

    renderWeights() {
      var st = this.st, t = this.t, self = this;
      var list = this.q('[data-sb-wlist]'), empty = this.q('[data-sb-wempty]');
      if (!list) return;
      var p = st.b ? this.map.b[st.b] : null;
      if (!p) {
        list.innerHTML = '';
        list.hidden = true;
        if (empty) empty.hidden = false;
        this._wkey = '';
        this.renderWeightLine();
        return;
      }
      if (empty) empty.hidden = true;
      list.hidden = false;
      var key = p.id + '|' + st.size + st.cl;
      if (this._wkey !== key) {
        this._wkey = key;
        var vs = this.vars(p).slice().sort(function (a, b) { return num(a[3]) - num(b[3]); });
        var low = this.priceRange(vs)[0];
        // a long lead time shows on the weight only when the weights differ (otherwise the tile already says it)
        var allLong = !!this.longLead(vs);
        // TD 2026-10-12 WEIGHT-A: the button shows only the weight (+ price / lead time); the body-weight range of the
        // chosen weight is one line under the buttons (renderWeightLine)
        list.innerHTML = vs.map(function (v) {
          var long = !allLong && (Number(v[7]) || 0) >= self.longDays;
          return '<button type="button" class="td-sb__opt td-sb__opt--wt" data-sb-weight="' + esc(v[3]) + '" aria-pressed="false">' +
            '<span class="td-sb__opt-title">' + esc(v[3]) + '</span>' +
            (v[4] !== low ? '<span class="td-sb__opt-price">' + esc(self.money(v[4])) + '</span>' : '') +
            (long ? '<span class="td-sb__opt-lead"><span class="sr-only">' + esc(t.lead_label || '') + ' </span>' + esc(v[6]) + '</span>' : '') +
            '</button>';
        }).join('');
      }
      this.qa('[data-sb-weight]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.sbWeight === st.w)); });
      this.renderWeightLine();
    }

    // TD 2026-10-12 WEIGHT-A: "Für Körpergewicht: bis 69 kg" for the chosen weight of the chosen blanket in the chosen
    // size + closure, under the weight buttons; hidden (and empty) without a weight or without a range. The chosen button
    // points to it (aria-describedby).
    weightRangeText() {
      var vb = this.blanketVariant(), r = vb ? this.rangeText(vb[5]) : '';
      return r ? (this.t.range_label || '') + ' ' + r : '';
    }

    renderWeightLine() {
      var line = this.q('[data-sb-wrange]');
      var textEl = line && line.querySelector('[data-sb-wrange-text]');
      if (!textEl) return;
      var text = this.weightRangeText(), st = this.st;
      if (textEl.textContent !== text) textEl.textContent = text;
      line.hidden = !text;
      this.qa('[data-sb-weight]').forEach(function (b) {
        if (text && b.dataset.sbWeight === st.w) b.setAttribute('aria-describedby', line.id);
        else b.removeAttribute('aria-describedby');
      });
    }

    // cheapest set in the chosen size + closure ({reg, set}); with partial = true it starts from what is already picked
    fromPrice(partial) {
      var self = this, st = this.st, minB = -1, minC = -1;
      var listB = partial && st.b ? [this.map.b[st.b]] : (this.d.b || []);
      var listC = partial && st.c ? [this.map.c[st.c]] : (this.d.c || []);
      var vb = partial ? this.blanketVariant() : null;
      if (vb) minB = vb[4];
      else listB.forEach(function (p) {
        self.vars(p).forEach(function (v) { if (minB < 0 || v[4] < minB) minB = v[4]; });
      });
      listC.forEach(function (p) {
        self.vars(p).forEach(function (v) { if (minC < 0 || v[4] < minC) minC = v[4]; });
      });
      if (minB < 0 || (minC < 0 && !this.noX)) return null;
      if (minC < 0) minC = 0; // SET-EXTRA without an orderable extra: the blanket alone
      return { reg: minB + minC, set: minB - this.discount(minB) + minC - this.discount(minC) };
    }

    renderFrom() {
      var el = this.q('[data-sb-from]'), txt = this.q('[data-sb-from-text]'), reg = this.q('[data-sb-from-reg]');
      if (!el || !txt) return;
      // SET-NEW: the selection is one of the set variants of this product (e.g. opened from Google Shopping): the price of
      // exactly this set ("Ihr Set: 218,70€"), the regular sum struck through – always the computed (cart) price
      var s = this.t.set_price && this.setVariant() ? this.sums() : null;
      if (s) {
        el.hidden = false;
        txt.textContent = fill(this.t.set_price, { price: this.money(s.total) });
        if (reg) {
          reg.hidden = s.reg === s.total;
          reg.innerHTML = this.srInstead() + esc(this.money(s.reg));
        }
        return;
      }
      var f = this.fromPrice(false);
      el.hidden = !f;
      if (!f) return;
      txt.textContent = this.fromText(f.set);
      if (reg) {
        reg.hidden = f.reg === f.set;
        reg.innerHTML = this.srInstead() + esc(this.money(f.reg));
      }
    }

    // the photo the tile already shows (loaded): the set picture changes at once, the sharp one follows
    tileSrc(kind, p) {
      var img = this.q('[data-sb-tiles="' + kind + '"] [data-sb-cell][data-id="' + p.id + '"] img');
      return img && img.complete && img.naturalWidth ? img.currentSrc || img.src : '';
    }

    setSlot(slot, p, kind, small) {
      if (!slot) return;
      var img = slot.querySelector('img');
      if (!img) return;
      var want = p ? (small ? (p.i || p.I) : (p.I || p.i)) : '';
      if (!want) {
        img.hidden = true;
        img.removeAttribute('src');
        img._want = '';
        slot.classList.remove('is-filled');
        return;
      }
      // SET-NEW: the photo Liquid already put there (preselected set) stays – no swap to the smaller tile photo and back
      if (img._want === undefined && img.getAttribute('src') === want) img._want = want;
      if (img._want !== want) {
        img._want = want;
        var quick = this.tileSrc(kind, p) || want;
        img.src = quick;
        if (quick !== want) {
          var pre = new Image();
          pre.onload = function () { if (img._want === want) img.src = want; };
          pre.src = want;
        }
      }
      img.hidden = false;
      slot.classList.add('is-filled');
    }

    missing() {
      var st = this.st, t = this.t, out = [];
      if (!st.b) out.push(t.need_blanket);
      else if (!st.w) out.push(t.need_weight);
      if (!st.c && !this.noX) out.push(t.need_cover);
      return out;
    }

    // the longer lead time of what is picked (blanket without weight: its longest variant)
    leadFor() {
      var st = this.st, cand = [], best = null;
      var vb = this.blanketVariant(), vc = this.coverVariant();
      if (vb) cand.push(vb);
      else if (st.b) cand = cand.concat(this.vars(this.map.b[st.b]));
      if (vc) cand.push(vc);
      cand.forEach(function (v) {
        if (!best || (Number(v[7]) || 0) > (Number(best[7]) || 0)) best = v;
      });
      return best && best[6] ? { text: best[6], days: Number(best[7]) || 0 } : null;
    }

    renderLead() {
      var el = this.q('[data-sb-lead]');
      if (!el) return;
      var ld = this.leadFor(), t = this.t, html = '';
      if (ld && t.expected_html) {
        // P03 rules (blanket template): 14+ days = calm box with calendar icon; 7–13 normal colour; below 7 green
        var long = ld.days >= this.longDays;
        var line = fill(t.expected_html, { value: esc(ld.text), color: ld.days >= 7 ? 'inherit' : '#15803d' });
        html = long
          ? '<p class="td-p03-lead td-p03-lead--buybox td-sb__lead-long" data-td-p03-days="' + ld.days + '">' + CAL_ICON + '<span>' + line + '</span></p>'
          : '<p class="td-sb__lead-line">' + line + '</p>';
      }
      if (this._leadHtml !== html) {
        this._leadHtml = html;
        el.innerHTML = html;
      }
      el.hidden = !html;
    }

    renderSummary() {
      var self = this, st = this.st, t = this.t, d = this.d;
      var pb = st.b ? this.map.b[st.b] : null, pc = st.c ? this.map.c[st.c] : null;
      var vb = this.blanketVariant(), vc = this.coverVariant();
      var sizeL = this.sizeLabel[st.size] || st.size, clL = d.cl[st.cl] || '';
      var sums = this.sums(), complete = !!sums;

      // Schritte erledigt? Schritt 1 hat Startwerte: erledigt, sobald er angetippt wurde oder weiter unten gewählt wird
      // SET-B3: 2 = Decke gewählt, 3 = Gewicht gewählt (eigener Schritt), 4 = 2. Bezug
      var done = { 1: !!(st.touched || st.b || st.c), 2: !!st.b, 3: !!vb, 4: !!vc };
      this.qa('[data-sb-step]').forEach(function (s) { s.classList.toggle('is-done', !!done[s.dataset.sbStep]); });

      // Set-Bild oben und in „Ihr Set“: zwei Felder, offen = „?“
      var alt = fill(t.pic_alt, {
        blanket: pb ? this.fullName(pb) + (st.w ? ' ' + st.w : '') : (t.pic_ph_b || t.open),
        cover: pc ? this.fullName(pc) : (t.pic_ph_c || t.open)
      });
      this.qa('[data-sb-pic]').forEach(function (pic) {
        pic.setAttribute('aria-label', alt);
        self.setSlot(pic.querySelector('[data-sb-slot="b"]'), pb, 'b');
        self.setSlot(pic.querySelector('[data-sb-slot="c"]'), pc, 'c');
      });
      this.setSlot(this.q('[data-sb-bslot="b"]'), pb, 'b', true);
      this.setSlot(this.q('[data-sb-bslot="c"]'), pc, 'c', true);

      // Zeilen: Set-Preis, regulär durchgestrichen
      var itemB = this.q('[data-sb-item="b"]'), itemC = this.q('[data-sb-item="c"]');
      if (itemB) {
        itemB.classList.toggle('is-open', !pb);
        itemB.querySelector('[data-sb-iname]').textContent = pb ? this.fullName(pb) : t.open;
        itemB.querySelector('[data-sb-imeta]').textContent = pb ? [sizeL, clL, st.w || ''].filter(Boolean).join(' · ') : '';
        var htmlB = '';
        if (vb) htmlB = this.priceHtml(vb[4], false);
        else if (pb) {
          var rb = this.priceRange(this.vars(pb));
          htmlB = this.priceHtml(rb[0], rb[1] > rb[0]);
        }
        itemB.querySelector('[data-sb-iprice]').innerHTML = htmlB;
      }
      if (itemC) {
        itemC.classList.toggle('is-open', !pc);
        itemC.querySelector('[data-sb-iname]').textContent = pc ? this.fullName(pc) : t.open;
        // SET-EXTRA: the extra has no size / closure, only its note (collar "2 kg")
        itemC.querySelector('[data-sb-imeta]').textContent = pc ? (pc.x ? pc.mt || '' : [sizeL, clL].join(' · ')) : '';
        itemC.querySelector('[data-sb-iprice]').innerHTML = vc ? this.priceHtml(vc[4], false) : '';
      }

      // Summe: Set-Preis, regulär durchgestrichen; Ersparnis bzw. Hinweis auf den Set-Rabatt
      var totalEl = this.q('[data-sb-total]'), totalReg = this.q('[data-sb-totalreg]');
      var saving = complete && sums.save > 0;
      if (totalEl) {
        totalEl.textContent = complete ? this.money(sums.total) : '–';
        totalEl.classList.toggle('is-sale', saving);
      }
      if (totalReg) {
        totalReg.hidden = !saving;
        totalReg.innerHTML = saving ? this.srInstead() + esc(this.money(sums.reg)) : '';
      }
      var saveBox = this.q('[data-sb-savebox]'), saveEl = this.q('[data-sb-save]');
      if (saveBox && saveEl) {
        saveBox.classList.toggle('is-saving', saving);
        saveEl.textContent = saving
          ? fill(t.save, { amount: this.money(sums.save), pct: d.disc })
          : fill(t.save_teaser, { pct: d.disc });
      }
      var monthly = this.q('[data-sb-monthly]');
      if (monthly) {
        // like snippets/td-monthly-prices.liquid on the PDP: price ÷ 12 (of the set price)
        var mHtml = complete && t.monthly_html ? fill(t.monthly_html, { price: esc(this.money(Math.round(sums.total / 12))) }) : '';
        if (monthly._html !== mHtml) {
          monthly._html = mHtml;
          monthly.innerHTML = mHtml;
        }
        monthly.hidden = !mHtml;
      }
      this.renderLead();

      // Hinweis + Button
      var miss = this.missing();
      var hintText = miss.length ? t.missing + ' ' + miss.join(' · ') : t.ready;
      var hint = this.q('[data-sb-hint]');
      if (hint) {
        hint.textContent = hintText;
        hint.classList.toggle('is-ready', !miss.length);
      }
      var add = this.q('[data-sb-add]');
      if (add && !this._busy) add.disabled = !complete;

      // Leiste unten: Preis (mit Set-Rabatt), vollständig: regulär durchgestrichen + „Sie sparen …“
      var bt = this.q('[data-sb-btotal]'), breg = this.q('[data-sb-breg]'), bs = this.q('[data-sb-bsave]');
      var bh = this.q('[data-sb-bhint]'), bb = this.q('[data-sb-barbtn]');
      if (bt) {
        var from = complete ? null : this.fromPrice(true);
        bt.textContent = complete ? this.money(sums.total) : (from ? this.fromText(from.set) : '');
      }
      if (breg) {
        breg.hidden = !saving;
        breg.innerHTML = saving ? this.srInstead() + esc(this.money(sums.reg)) : '';
      }
      if (bs) {
        bs.hidden = !saving;
        bs.textContent = saving ? fill(t.bar_save, { amount: this.money(sums.save), pct: d.disc }) : '';
      }
      if (bh) {
        bh.textContent = complete ? '' : hintText;
        bh.hidden = complete;
      }
      if (bb && !this._busy) bb.textContent = complete ? t.bar_add : t.bar_next;
    }

    /* ---------- bar at the bottom ---------- */
    setupBar() {
      var self = this;
      var bar = this.q('[data-sb-bar]'), hero = this.q('[data-sb-hero]'), panel = this.q('[data-sb-panel]'), add = this.q('[data-sb-add]');
      if (!bar || !hero || !panel || !add || !('IntersectionObserver' in window)) return;
      var foot = document.querySelector('.shopify-section--footer') || document.querySelector('footer');
      var mq = window.matchMedia ? window.matchMedia('(min-width: 1000px)') : null;
      var vis = { hero: true, panel: false, add: false, layout: true, foot: false };
      var update = function () {
        // phones / tablets: between the set picture and "Ihr Set"; desktop ("Ihr Set" sticks on the left): only while
        // its button is not fully on screen (short windows); never over the footer
        var desk = !!(mq && mq.matches);
        var show = !vis.foot && (desk ? (vis.layout && !vis.add) : (!vis.hero && !vis.panel));
        bar.classList.toggle('is-visible', show);
      };
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var tg = en.target;
          if (tg === hero) vis.hero = en.isIntersecting;
          else if (tg === panel) vis.panel = en.isIntersecting;
          else if (tg === add) vis.add = en.isIntersecting && en.intersectionRatio > 0.98;
          else if (tg === self) vis.layout = en.isIntersecting;
          else if (tg === foot) vis.foot = en.isIntersecting;
        });
        update();
      }, { threshold: [0, 1] });
      [hero, panel, add, this].concat(foot ? [foot] : []).forEach(function (el) { self._io.observe(el); });
      if (mq) {
        this._mq = mq;
        this._mqH = update;
        if (mq.addEventListener) mq.addEventListener('change', update);
        else if (mq.addListener) mq.addListener(update);
      }
    }

    goTo(target) {
      if (!target) return;
      target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      focusEl(target);
    }

    barAction() {
      if (this.blanketVariant() && (this.noX || this.coverVariant())) return this.addToCart(true);
      var st = this.st, target = null;
      // SET-B3: Decke → Schritt 2, Gewicht → Schritt 3, 2. Bezug → Schritt 4
      if (!st.b) target = this.q('[data-sb-step="2"] .td-sb__step-title');
      else if (!st.w) target = this.q('[data-sb-step="3"] .td-sb__step-title');
      else if (!st.c && !this.noX) target = this.q('[data-sb-step="4"] .td-sb__step-title');
      this.goTo(target);
    }

    toPanel() {
      this.goTo(this.q('[data-sb-panel] .td-sb__panel-title'));
    }

    /* ---------- add to cart ---------- */
    errorText(json) {
      var desc = json && (typeof json.description === 'string' ? json.description : json.message);
      return this.t.error + (desc ? ' ' + desc : '');
    }

    fail(text, fromBar) {
      var msg = this.q('[data-sb-msg]'), add = this.q('[data-sb-add]');
      if (msg) msg.textContent = text;
      this.say(text, true);
      if (fromBar && msg) {
        // the bar sits away from "Ihr Set": bring the message and its button into view
        msg.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
        focusEl(add);
      }
    }

    // GET /cart.js; tries = 1 + retries with a short pause (busy store: 429)
    async getCart(root, tries) {
      for (var i = 0; i < (tries || 1); i++) {
        if (i) await wait(i * 700);
        try {
          var r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (r.ok) {
            var j = await r.json();
            if (j && j.items) return j;
          }
        } catch (e) { /* next try */ }
      }
      return null;
    }

    codesOf(cart) {
      return ((cart && cart.discount_codes) || []).map(function (c) { return c && c.code ? String(c.code) : ''; }).filter(Boolean);
    }

    // POST /cart/update.js with the full code list (it REPLACES the cart's codes) + the drawer sections; one retry
    async updateCodes(root, codes, sections) {
      var body = { discount: codes.join(',') };
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }
      for (var i = 0; i < 3; i++) {
        if (i) await wait(i * 800);
        try {
          var r = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          if (r.ok) {
            var j = await r.json();
            if (j && j.items && Array.isArray(j.discount_codes)) return j;
          }
        } catch (e) { /* next try */ }
      }
      return null;
    }

    // does our code apply, and what did it take off the two set lines (cents)? full = the configured percentage on
    // both lines (±1 cent per item); perSet = the amount of ONE set (the same set twice is one line with quantity 2)
    setDiscount(cart, code, setId) {
      var pct = Number(this.d.disc) || 0;
      var applicable = ((cart && cart.discount_codes) || []).some(function (c) {
        return c && sameCode(c.code, code) && c.applicable;
      });
      var amount = 0, perSet = 0, expected = 0, tol = 0;
      if (applicable) {
        (cart.items || []).forEach(function (it) {
          if (!it.properties || it.properties._td_set !== setId) return;
          var qty = Math.max(1, Number(it.quantity) || 1), got = 0;
          (it.line_level_discount_allocations || []).forEach(function (a) {
            var app = a.discount_application || {};
            if (sameCode(app.title, code)) got += Number(a.amount) || 0;
          });
          amount += got;
          perSet += Math.round(got / qty);
          expected += Math.round((Number(it.original_line_price) || 0) * pct / 100);
          tol += qty;
        });
      }
      var applied = applicable && amount > 0;
      return {
        applicable: applicable,
        applied: applied,
        amount: amount,
        perSet: perSet,
        full: applied && pct > 0 && Math.abs(amount - expected) <= tol
      };
    }

    hasSet(cart, setId) {
      return !!setId && ((cart && cart.items) || []).some(function (it) { return it.properties && it.properties._td_set === setId; });
    }

    // every cart change (drawer: remove, quantity; other features): the page stops claiming a discount the cart no
    // longer gives, and our code without effect is taken out again
    onCartChange(ev) {
      var c = ev && ev.detail && ev.detail.cart;
      if (!c || !Array.isArray(c.discount_codes)) return;
      var code = this.code();
      if (code) {
        var on = c.discount_codes.some(function (x) { return x && sameCode(x.code, code) && x.applicable; });
        if (this._claim && !on) {
          var ok = this.q('[data-sb-ok]');
          if (ok) ok.textContent = '';
          this._claim = false;
        }
        if (this._discErr && (on || !this.hasSet(c, this._last && this._last.setId))) {
          // the set got its discount after all, or it is no longer in the cart: the note is done
          this._discErr = false;
          this.discMsg('');
        }
      }
      this.checkIdle(c);
    }

    // our code without effect (e.g. the cover was removed from the cart) is taken out again, so it does not reach the
    // checkout as an invalid code; only a code this page redeemed in this browser session (CART-UP2 does the same
    // for its cover code, since 03.10.2026 TDB8BNN7R instead of BEZUG10)
    checkIdle(c) {
      var mine = store.get(CODE_KEY), entry = null;
      // APP-DISC: only the configured code, and only while one is configured (none since 05.10.2026)
      if (mine && !sameCode(mine, this.code())) {
        store.remove(CODE_KEY);
        return;
      }
      if (!mine || !c || !Array.isArray(c.discount_codes)) return;
      c.discount_codes.forEach(function (x) { if (x && sameCode(x.code, mine)) entry = x; });
      if (!entry) {
        store.remove(CODE_KEY);
        return;
      }
      if (entry.applicable) return;
      // a moment later and from a fresh cart: other features (CART-UP2) tidy their own code on the same change
      clearTimeout(this._idleT);
      this._idleT = setTimeout(this.dropIdle.bind(this), 1500);
    }

    async dropIdle() {
      var mine = store.get(CODE_KEY);
      if (!mine || this._dropping) return;
      if (!sameCode(mine, this.code())) {
        // APP-DISC: no configured code (or another one): never take a code out of the cart
        store.remove(CODE_KEY);
        return;
      }
      if (this._busy) {
        this._idleT = setTimeout(this.dropIdle.bind(this), 1500);
        return;
      }
      this._dropping = true;
      try {
        var root = this.root(), entry = null;
        var c = await this.getCart(root, 2);
        if (!c || !Array.isArray(c.discount_codes)) return;
        c.discount_codes.forEach(function (x) { if (x && sameCode(x.code, mine)) entry = x; });
        if (!entry) {
          store.remove(CODE_KEY);
          return;
        }
        if (entry.applicable) return;
        var rest = this.codesOf(c).filter(function (x) { return !sameCode(x, mine); });
        var sections = document.querySelector('cart-drawer') ? this.bundledSections() : [];
        var res = await this.updateCodes(root, rest, sections);
        if (!res) return;
        store.remove(CODE_KEY);
        // the drawer shows the cart without the code (it does not open for this)
        if (res.sections) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'td-set:code-removed', cart: res }
          }));
        }
      } catch (e) {
        /* the next cart change tries again */
      } finally {
        this._dropping = false;
      }
    }

    // 'Hinzugefügt' row at the top of the drawer, focused once the drawer is open (like Q13 on the product page);
    // SET-B3 (Felix 03.10.2026: „too much space text in drawer when item is added“): one short line „Set hinzugefügt“,
    // no product names (the drawer lists them right below); disc = { text, calm, retry } only when the set discount
    // did not apply or could not be redeemed
    addedRow(drawer, disc) {
      var self = this;
      drawer.querySelectorAll('.td-sb-added').forEach(function (n) { n.remove(); });
      var row = document.createElement('div');
      row.className = 'td-sb-added';
      row.tabIndex = -1;
      row.innerHTML = OK_ICON + '<div class="td-sb-added__text"><p class="td-sb-added__title"></p></div>';
      row.querySelector('.td-sb-added__title').textContent = this.t.added_row || this.t.added || '';
      var wrap = row.querySelector('.td-sb-added__text');
      if (disc && disc.text) {
        row.classList.add('td-sb-added--note');
        var dp = document.createElement('p');
        dp.className = 'td-sb-added__disc' + (disc.calm ? ' td-sb-added__disc--calm' : '');
        dp.textContent = disc.text;
        wrap.appendChild(dp);
        if (disc.retry && this.t.disc_retry) {
          // the set is in the cart, only the code is redeemed again
          var rb = document.createElement('button');
          rb.type = 'button';
          rb.className = 'td-sb-added__retry';
          rb.setAttribute('data-sb-retry', '');
          rb.textContent = this.t.disc_retry;
          rb.addEventListener('click', function () { self.retryCode(); });
          wrap.appendChild(rb);
        }
      }
      var list = drawer.querySelector('.cart-drawer__items');
      if (list) list.before(row);
      else drawer.prepend(row);
      var focused = false;
      var focusRow = function () {
        if (focused || !row.isConnected || !drawer.hasAttribute('open')) return;
        focused = true;
        focusEl(row);
      };
      drawer.addEventListener('dialog:after-show', focusRow, { once: true });
      setTimeout(focusRow, 700);
      drawer.addEventListener('dialog:after-hide', function () { row.remove(); }, { once: true });
    }

    watchDrawer(disc) {
      var self = this, timer = 0;
      var onRefreshed = function (ev) {
        var dr = ev.target && ev.target.closest ? ev.target.closest('cart-drawer') : null;
        if (!dr) return;
        document.removeEventListener('cart-drawer:refreshed', onRefreshed);
        clearTimeout(timer);
        self.addedRow(dr, disc);
      };
      timer = setTimeout(function () { document.removeEventListener('cart-drawer:refreshed', onRefreshed); }, 15000);
      document.addEventListener('cart-drawer:refreshed', onRefreshed);
    }

    // busy: the focused button stays focusable (aria-disabled, no `disabled`), the steps cannot change meanwhile
    setBusy(on) {
      var steps = this.q('[data-sb-steps]');
      this._busy = !!on;
      if (steps) {
        // only the steps are busy: the live regions of the component must keep talking
        if (on) {
          steps.setAttribute('aria-busy', 'true');
          steps.setAttribute('inert', '');
        } else {
          steps.removeAttribute('aria-busy');
          steps.removeAttribute('inert');
        }
      }
      [this.q('[data-sb-add]'), this.q('[data-sb-barbtn]')].forEach(function (b) {
        if (!b) return;
        if (on) {
          b.setAttribute('aria-disabled', 'true');
          b.setAttribute('aria-busy', 'true');
        } else {
          b.removeAttribute('aria-disabled');
          b.removeAttribute('aria-busy');
        }
      });
    }

    // our code into the cart, the codes already there stay: { cart (with the drawer sections) | null, disc }
    // disc.error = the code step could not run (cart unreadable, store busy): nothing was changed, a retry can follow
    async redeem(root, code, setId, sections, beforeP) {
      var prev = (beforeP ? await beforeP : null) || (await this.getCart(root, 3));
      // codes unknown: never overwrite them (the update REPLACES the cart's codes)
      if (!prev) return { cart: null, disc: { error: true } };
      var prevCodes = this.codesOf(prev), codes = prevCodes.slice();
      if (!codes.some(function (c) { return sameCode(c, code); })) codes.push(code);
      var cart = await this.updateCodes(root, codes, sections);
      if (!cart) return { cart: null, disc: { error: true } };
      var disc = this.setDiscount(cart, code, setId);
      if (!disc.applicable && codes.length !== prevCodes.length) {
        // our code does not apply at all: the cart gets its previous codes back (no unusable code at the checkout)
        var restored = await this.updateCodes(root, prevCodes, sections);
        if (restored) cart = restored;
      }
      if (disc.applicable) store.set(CODE_KEY, code);
      return { cart: cart, disc: disc };
    }

    // page messages after an add / a retry; plain prices only when the cart really refused the code (not when the
    // store was just busy)
    discState(disc) {
      var t = this.t, d = this.d, ok = this.q('[data-sb-ok]');
      var applied = !!(disc && disc.applied), err = !!(disc && disc.error);
      if (disc && !err) this.setNoDisc(!applied);
      this._discErr = err;
      this._claim = applied;
      var okText = t.added || '';
      if (applied) {
        okText += ' ' + (disc.full
          ? fill(t.disc_applied, { pct: d.disc })
          : fill(t.disc_applied_amt, { amount: this.money(disc.perSet) }));
      }
      if (ok) ok.textContent = okText.trim();
      this.discMsg(disc && !applied ? (err ? t.disc_error : t.disc_failed) : '', err);
    }

    // the note of the "Hinzugefügt" row in the drawer: only when the set discount did not apply / could not be redeemed
    // (SET-B3: an applied discount shows in the drawer's own lines, the row stays one line)
    rowFor(disc) {
      var t = this.t;
      if (!disc) return null;
      if (disc.error) return { calm: true, retry: true, text: t.disc_error };
      if (!disc.applied) return { calm: true, text: t.disc_failed };
      return null;
    }

    // after the add (and the code): messages on the page, then the drawer with the "Hinzugefügt" row (or the cart page)
    async showAdded(root, out, addSections) {
      var disc = out.disc, cart = out.cart;
      this.discState(disc);
      var settings = window.themeVariables && window.themeVariables.settings;
      var drawer = document.querySelector('cart-drawer');
      if ((settings && settings.cartType === 'page') || !drawer) {
        // cart page: go there, unless the discount still has to be redeemed (note + button are on this page)
        if (disc && disc.error) {
          this.focusDisc();
          return;
        }
        window.location.href = root + 'cart';
        return;
      }
      if (!cart || !cart.sections) {
        // the drawer sections came with the add; the theme needs a full cart with them (count, codes)
        var full = await this.getCart(root, 2);
        if (full && addSections) full.sections = addSections;
        cart = full;
      }
      this.watchDrawer(this.rowFor(disc));
      if (cart && cart.sections) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart }
        }));
      } else {
        // nothing readable right now: the theme loads cart and drawer itself, the drawer opens meanwhile
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof drawer.show === 'function') drawer.show();
      }
    }

    focusDisc() {
      var btn = this.q('[data-sb-retry]');
      if (btn && !btn.hidden) {
        btn.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
        focusEl(btn);
      }
      this.say(this.t.disc_error, true);
    }

    // "Set-Rabatt einlösen" (page or drawer row): the set is already in the cart, only the code is redeemed again
    async retryCode() {
      var code = this.code(), last = this._last;
      if (this._busy || !code || !last) return;
      var t = this.t, root = this.root(), html = document.documentElement, out = null;
      var btns = Array.prototype.slice.call(document.querySelectorAll('[data-sb-retry]'));
      this.setBusy(true);
      btns.forEach(function (b) {
        b.setAttribute('aria-busy', 'true');
        b.setAttribute('aria-disabled', 'true');
        b._label = b.textContent;
        if (t.retry_busy) b.textContent = t.retry_busy;
      });
      if (t.retry_busy) this.say(t.retry_busy);
      html.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      try {
        out = await this.redeem(root, code, last.setId, this.bundledSections(), null);
        // still not possible: nothing changed in the cart, the notes and buttons stay
        if (out.disc && out.disc.error) this.discState(out.disc);
        else await this.showAdded(root, out, null);
      } catch (e) {
        out = { disc: { error: true } };
        this.discState(out.disc);
      } finally {
        html.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        this.setBusy(false);
        btns.forEach(function (b) {
          b.removeAttribute('aria-busy');
          b.removeAttribute('aria-disabled');
          if (b._label) b.textContent = b._label;
        });
        this.renderSummary();
      }
      if (out && out.disc && out.disc.error) this.say(t.disc_error, true);
    }

    async addToCart(fromBar) {
      if (this._busy) return;
      var vb = this.blanketVariant(), vc = this.noX ? null : this.coverVariant();
      if (!vb || (!vc && !this.noX)) {
        this.renderSummary();
        return;
      }
      var t = this.t, html = document.documentElement;
      var add = this.q('[data-sb-add]');
      var label = add ? add.textContent : '';
      this.clearMsgs();
      this._discErr = false;
      this.discMsg('');
      this.setBusy(true);
      if (add && t.busy) add.textContent = t.busy;
      if (t.busy) this.say(t.busy);

      var setId = vc ? setKey(vb[0], vc[0]) : '';
      var root = this.root(), code = this.code(), sections = this.bundledSections();
      // cover first: the cart lists the last added line on top, so the blanket comes first
      var body = {
        items: [
          { id: vc ? vc[0] : vb[0], quantity: 1, properties: { _td_set: setId } },
          { id: vb[0], quantity: 1, properties: { _td_set: setId } }
        ]
      };
      if (this.xm) {
        // SET-EXTRA: exactly one of this product's set variants = that set variant itself (native bundle, fixed price, the
        // same SKU as Google Shopping), one line without _td_set; no orderable extra = the blanket alone, one line
        var sv = vc ? this.setVariant() : null;
        if (sv) body.items = [{ id: sv[0], quantity: 1 }];
        else if (!vc) body.items = [{ id: vb[0], quantity: 1 }];
      }
      // the drawer sections always come with the add: the drawer opens even if the code step fails afterwards
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }
      var added = false, json = {};
      html.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      try {
        // the codes already in the cart stay (the update REPLACES the list): read them while the items are added
        var before = code ? this.getCart(root) : null;
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        try { json = await res.json(); } catch (e) { json = {}; }
        if (!res.ok) {
          this.fail(this.errorText(json), fromBar);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        // from here on both items are in the cart: whatever fails next, no second add
        added = true;
        this._last = { setId: setId };
        var out = code ? await this.redeem(root, code, setId, sections, before) : { cart: null, disc: null };
        await this.showAdded(root, out, json.sections);
      } catch (e) {
        if (!added) this.fail(t.error, fromBar);
        else {
          try {
            await this.showAdded(root, { cart: null, disc: code ? { error: true } : null }, json && json.sections);
          } catch (e2) {
            window.location.href = root + 'cart';
          }
        }
      } finally {
        html.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        this.setBusy(false);
        if (add) add.textContent = label;
        this.renderSummary();
      }
    }
  }

  window.customElements.define('td-set-builder', TdSetBuilder);
})();
